import { Button, Column, Grid } from "@carbon/react";
import {
  Chart,
  ChartWithSummary,
  Card,
  DatePicker,
  Filter,
  QuickTableFilterTabs,
} from "../../components";
import {
  fullWidthChartData,
  total,
  chartTitle,
  smallChartsData,
  summaryTableData,
} from "../../test-data";

import { formatAsCurrency, formatNumberWithCommas } from "../../utils";

import printIcon from "../../assets/icons/printicon.png";
import downloadIcon from "../../assets/icons/arrowdown.svg";

import "./_revenue.scss";
export const View = (props) => {
  return (
    <>
      <Column sm={4} md={8} lg={16} className="container2">
        <div className="flex-container report-breakdown--header justify-content--start">
          <div className="flex-box">
            <QuickTableFilterTabs
              queryStringTabNavLinks={props.queryStringTabs}
            />
          </div>

          <div className="flex-container report-filter--container">
            <div className="mr-5">
              <DatePicker startDate="Jun 24" endDate="Jun 31" />
            </div>

            {/* <Button
            size="sm"
            kind="tertiary"
            className="switchapp-themed print"
            iconDescription="Add to balance"
          >
            <img src={printIcon} alt="print document" />
            Print
          </Button> */}
          </div>
        </div>

        <Column sm={4} md={8} lg={16} className="top2">
          <Grid>
            <Column sm={4} md={8} lg={3}>
              <h3>
                <strong>Revenue Overview</strong>
              </h3>
            </Column>
            <Column sm={4} md={8} lg={2}>
              {/* <Filter /> */}
            </Column>{" "}
            <Column sm={4} md={8} lg={2}>
              <DatePicker startDate="Jun 13" endDate="Jun 20" />
            </Column>
          </Grid>
        </Column>
        <Grid>
          <Column sm={4} md={8} lg={8}>
            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[8]}
              total={`${
                smallChartsData[8].prefix || ""
              }${formatNumberWithCommas(smallChartsData[8].total)}${
                smallChartsData[8].suffix || ""
              }`}
            />
          </Column>
          <Column sm={4} md={8} lg={8}>
            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[9]}
              total={`${
                smallChartsData[9].prefix || ""
              }${formatNumberWithCommas(smallChartsData[9].total)}${
                smallChartsData[9].suffix || ""
              }`}
            />
          </Column>
        </Grid>
        <Column sm={4} md={8} lg={16} className="head">
          <Grid>
            <Column sm={4} md={8} lg={15} className="summary">
              <h5>Balance summary</h5>
              <p>
                Shows starting and ending balance in your SwitchApp account.
                Starting balance is the sum of your available balance and
                pending balance. Changes to your balance come from activity
                (payments, refunds, transfers, etc.) and from payouts to your
                bank (aggregated here and broken out in detail in the reports
                below).
              </p>
            </Column>
            <Column sm={4} md={8} lg={1}>
              <Button
                size="sm"
                kind="tertiary"
                className="switchapp-themed print"
                iconDescription="Download document icon"
              >
                <img src={downloadIcon} alt="download document" />
                Download
              </Button>
            </Column>
          </Grid>
        </Column>

        <Column sm={4} md={8} lg={16} className="head balanceSum">
          <Grid>
            <Column sm={4} md={8} lg={15}>
              <p>Starting balance —Jul 1, 2022 13:00pm</p>
              <p>Net balance change from activity</p>
              <p>Ending balance —Aug 1, 2022 18:00pm</p>
            </Column>
            <Column sm={4} md={8} lg={1}>
              <p>350000</p>
              <p>350000</p>
              <p>350000</p>
            </Column>
          </Grid>
        </Column>
        <Column Column sm={4} md={8} lg={16} className="parts">
          <Grid>
            <Column sm={4} md={8} lg={15}>
              <p>
                <strong>Ending balance —Aug 1, 2022 18:00pm</strong>
              </p>
            </Column>
            <Column sm={4} md={8} lg={1}>
              <p>3000000</p>
            </Column>
          </Grid>
        </Column>
        <Column Column sm={4} md={8} lg={16}>
          <Grid>
            <Column Column sm={4} md={8} lg={15}>
              <h5>
                <strong>Balance change from activity</strong>
              </h5>
              <p>
                Detailed breakdown of the balance change from activity line from
                the above summary report includes changes to your SwitchApp
                balance from activity payments, refunds, transfers, etc,
                excluding payouts as well as itemized downloads.
              </p>
              <Grid>
                <Column Column sm={4} md={8} lg={5}>
                  <p>Changes</p>
                </Column>
                <Column Column sm={4} md={8} lg={5}>
                  <p>Courts</p>
                </Column>
                <Column Column sm={4} md={8} lg={5}>
                  <p>300</p>
                </Column>
              </Grid>
            </Column>
          </Grid>
          <Column className="darks">
            <Grid>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={4}>
                <p>Gross amount</p>
              </Column>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={1}>
                <p>400000</p>
              </Column>
            </Grid>
          </Column>
          <Column className="">
            <Grid>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={4}>
                <p>Gross amount</p>
              </Column>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={1}>
                <p>400000</p>
              </Column>
            </Grid>
          </Column>
          <Column className="darks">
            <Grid>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={4}>
                <p>Gross amount</p>
              </Column>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={1}>
                <p>400000</p>
              </Column>
            </Grid>
          </Column>
          <Column className="">
            <Grid>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={4}>
                <p>Gross amount</p>
              </Column>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={1}>
                <p>400000</p>
              </Column>
            </Grid>
          </Column>

          <Grid>
            <Column sm={4} md={8} lg={15}>
              <h5>
                <strong>Payouts</strong>
              </h5>
              <p>
                Detailed breakdown of the total payouts line from the above
                Balances Summaey report includes changes to your SwitchApp
                balance, from payouts to your bank, as well as itemized
                downloads
              </p>
              <Grid>
                <Column sm={4} md={8} lg={5}>
                  <p>Payouts</p>
                </Column>
                <Column sm={4} md={8} lg={5}>
                  <p>Payouts</p>
                </Column>
                <Column sm={4} md={8} lg={5}>
                  <p>Payouts</p>
                </Column>
              </Grid>
            </Column>
            <Column sm={4} md={8} lg={1}>
              <Button
                size="sm"
                kind="tertiary"
                className="switchapp-themed print"
                iconDescription="Download document icon"
              >
                <img src={downloadIcon} alt="download document" />
                Download
              </Button>
            </Column>
          </Grid>

          <Column className="darks">
            <Grid>
              <Column sm={4} md={8} lg={5}>
                &nbsp;
              </Column>
              <Column sm={4} md={8} lg={10}>
                <p>Gross amount</p>
              </Column>
              <Column sm={4} md={8} lg={1}>
                <p>40000</p>
              </Column>
            </Grid>
          </Column>
        </Column>
      </Column>
    </>
  );
};
